export type Tomo = {
  numero: string
  titulo: string
  descripcion: string
}

export type Bono = {
  codigo: string
  titulo: string
  descripcion: string
  valor: string
}

export type Testimonio = {
  nombre: string
  rol: string
  pais: string
  iniciales: string
  texto: string
}

export const heroBullets = [
  'Mensajes listos para copiar y pegar',
  'Protocolos para crisis, quejas y reseñas',
  'Checklists para limpieza y check-in',
  'Guías para cobrar más y filtrar mejores huéspedes',
  '100% PDF · Acceso inmediato',
]

export const socialStats = [
  { valor: '+1.000', etiqueta: 'Anfitriones' },
  { valor: '4.9/5', etiqueta: 'Calificación' },
  { valor: '6', etiqueta: 'Tomos' },
  { valor: '5', etiqueta: 'Bonos' },
]

export const testimonios: Testimonio[] = [
  {
    nombre: 'Marcos R.',
    rol: 'Anfitrión',
    pais: 'México',
    iniciales: 'MR',
    texto:
      'Pasé de estar pegado al chat a que todo fluya solo. Mis huéspedes están felices y yo también.',
  },
  {
    nombre: 'Carolina P.',
    rol: 'Administradora',
    pais: 'Colombia',
    iniciales: 'CP',
    texto:
      'Los guiones son universales. La secuencia de mensajes me ahorra horas cada semana.',
  },
  {
    nombre: 'Diego G.',
    rol: 'Dueño de propiedad',
    pais: 'Argentina',
    iniciales: 'DG',
    texto:
      'Cobro más caro por noche y tengo mejores reseñas. La mejor inversión que hice en mi propiedad.',
  },
]

export const painPoints = [
  'Te escriben a las 2 a.m. y no sabés qué responder sin arriesgar la reseña.',
  'Respondés las mismas preguntas una y otra vez.',
  'Cada notificación te acelera el pulso: puede ser una queja.',
  'No sabés cómo pedir reseñas sin sonar desesperado.',
  'Coordinás limpieza, entrada, salida y problemas a mano.',
  'Airbnb te da ingresos, pero también te roba tiempo y descanso.',
]

export const comoFunciona = [
  {
    titulo: 'Estudia el Módulo',
    detalle: 'Elige el área de tu negocio que quieres profesionalizar hoy.',
  },
  {
    titulo: 'Entiende el Proceso',
    detalle: 'Aprende la lógica detrás de los manuales y protocolos técnicos.',
  },
  {
    titulo: 'Aplica el Criterio',
    detalle:
      'Implementa el método en tu gestión diaria y establece tus propias reglas.',
  },
  {
    titulo: 'Lidera el Negocio',
    detalle:
      'Deja de reaccionar al caos y comienza a dirigir una operación estandarizada.',
  },
]

export const tomos: Tomo[] = [
  {
    numero: 'Tomo 1',
    titulo: 'Configuración Perfecta',
    descripcion:
      'Aprende a estructurar tu anuncio desde cero para que sea lucrativo.',
  },
  {
    numero: 'Tomo 2',
    titulo: 'Mensajes Sistematizados',
    descripcion:
      'Domina el arte de las respuestas listas para cada situación sin perder el toque humano.',
  },
  {
    numero: 'Tomo 3',
    titulo: 'Check-in Remoto',
    descripcion:
      'El método técnico para gestionar la entrada y salida 100% sin tu presencia.',
  },
  {
    numero: 'Tomo 4',
    titulo: 'Maximiza tus Lucros',
    descripcion:
      'Estrategias avanzadas para subir tus precios y rentabilidad los 365 días.',
  },
  {
    numero: 'Tomo 5',
    titulo: 'Plantillas de Mensajes',
    descripcion:
      'Tu biblioteca de comunicación estratégica para cada interacción con el huésped.',
  },
  {
    numero: 'Tomo 6',
    titulo: 'Listas de Verificación',
    descripcion:
      'El control de calidad definitivo: checklists de limpieza, inventario y mantenimiento.',
  },
]

export const bonos: Bono[] = [
  {
    codigo: 'Bono 1',
    titulo: 'El Guion del 5 Estrellas',
    descripcion:
      'El mensaje exacto para pedir reseñas sin sonar insistente ni desesperado.',
    valor: '$17',
  },
  {
    codigo: 'Bono 2',
    titulo: 'Los 20 Imprescindibles',
    descripcion:
      'La lista de objetos simples que elevan la experiencia del huésped y aparecen en las reseñas.',
    valor: '$15',
  },
  {
    codigo: 'Bono 3',
    titulo: 'Diccionario del Host',
    descripcion:
      '30 respuestas listas para descuentos, visitas, reglas, quejas y situaciones incómodas.',
    valor: '$27',
  },
  {
    codigo: 'Bono 4',
    titulo: 'Checklist Pre Check-in',
    descripcion:
      'La revisión rápida para evitar errores antes de que llegue cada huésped.',
    valor: '$17',
  },
  {
    codigo: 'Bono 5',
    titulo: 'Kit de Emergencias',
    descripcion:
      'Contactos, recursos y pasos básicos para actuar rápido cuando algo falla.',
    valor: '$19',
  },
]

export const beneficiosRiesgo = [
  'Menos mensajes repetidos.',
  'Menos errores de check-in.',
  'Menos improvisación ante problemas.',
  'Más claridad para el huésped.',
  'Más control sobre tu operación.',
  'Más posibilidades de reseñas positivas.',
]

export const incluyeOferta = [
  '6 tomos principales',
  '5 bonos estratégicos',
  'Mensajes copy-paste',
  'Checklists y protocolos',
  'Acceso inmediato',
  'Garantía 7 días',
]

export const faqs = [
  {
    pregunta: '¿Sirve si solo tengo una propiedad?',
    respuesta:
      'Sí. De hecho, es el mejor momento para empezar con sistema antes de que el caos crezca.',
  },
  {
    pregunta: '¿Sirve si uso co-anfitriones?',
    respuesta:
      'Sí, es la herramienta perfecta para estandarizar cómo ellos responden por ti.',
  },
  {
    pregunta: '¿Necesito saber tecnología?',
    respuesta:
      'No. Solo necesitás copiar, pegar y adaptar mensajes, checklists y protocolos.',
  },
  {
    pregunta: '¿Es un curso en video?',
    respuesta: 'No. Es 100% PDF, pensado para leer rápido y aplicar hoy mismo.',
  },
  {
    pregunta: '¿Funciona para cualquier país?',
    respuesta:
      'Sí. Está pensado para anfitriones de Airbnb y alquileres temporarios del mercado hispanohablante.',
  },
  {
    pregunta: '¿Cómo voy a recibir el sistema?',
    respuesta:
      'Recibes acceso inmediato a nuestra biblioteca digital de manuales, guías técnicas y protocolos en formato PDF. Está diseñado para que puedas estudiarlo e implementarlo a tu propio ritmo, sin necesidad de softwares complicados ni herramientas externas.',
  },
  {
    pregunta: '¿Tiene garantía?',
    respuesta:
      'Sí. 7 días de garantía: si no te ahorra al menos 5 horas de chat, te devolvemos el 100%.',
  },
]
